import React from 'react';
import { Step, StepLabel, Stepper } from '@mui/material';

export const BOOKING_STEP_LABELS = [
  { id: 'dates', label: 'Termin i zakwaterowanie' },
  { id: 'customer', label: 'Dane osobowe' },
  { id: 'payment', label: 'Płatność' },
];

export const BOOKING_PAYMENT_STEP_INDEX = 2;

const BookingStepper = ({ activeStep }) => (
  <Stepper
    activeStep={activeStep}
    orientation="horizontal"
    sx={{ mb: 3, display: { xs: 'none', sm: 'flex' } }}
  >
    {BOOKING_STEP_LABELS.map(({ id, label }) => (
      <Step key={id}>
        <StepLabel>{label}</StepLabel>
      </Step>
    ))}
  </Stepper>
);

export default BookingStepper;
